/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPnnLoadSched.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/pnn-load-sched";

export class AutogenModelPnnLoadSched<RowType extends ModelRow> extends Endpoint<RowType, RowPnnLoadSchedFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPnnLoadSched extends ModelRow<RowPnnLoadSchedFields> {
	constructor(values?: Partial<RowPnnLoadSchedFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPnnLoadSchedFields {
	company_id: string;
	schedule_id: string;
	time_code: string;
	time_descr: string;
}

